import { lazy } from 'react';

export const WelcomeScreenAsync = lazy(() => import('./WelcomeScreen')
    .then(({ WelcomeScreen }) => ({ default: WelcomeScreen })));
